// extracted by mini-css-extract-plugin
export var addButton = "_5m-d";
export var bullets = "_5m-e";
export var compact = "_5m-2";
export var container = "_5m-j";
export var extendedWarrantyModal = "_5m-f";
export var learn = "_5m-l";
export var learnMore = "_5m-g";
export var offeringOption = "_5m-3";
export var offeringPrice = "_5m-8";
export var offeringSubtitle = "_5m-7";
export var offeringTitle = "_5m-6";
export var offeringsContainer = "_5m-0";
export var pdpTilesBackground = "_5m-n";
export var plan = "_5m-m";
export var regular = "_5m-1";
export var remove = "_5m-k";
export var seeDetailsIcon = "_5m-i";
export var seeDetailsLink = "_5m-h";
export var selectedOption = "_5m-4";
export var shieldIcon = "_5m-b";
export var shieldIconCompact = "_5m-c";
export var subtitle = "_5m-a";
export var title = "_5m-9";
export var unselectedOption = "_5m-5";